import { Box } from '@domain-group/suit-theme'

import OrderItem from './OrderItem'

import useImportProjectMedia from '../../hooks/useImportProjectMedia'

const requestOptions = {
  include_attachment_attachable: true,
  include_order_item_campaign_id: true,
  include_order_item_service: true,
}

interface ProjectMediaProps {
  campaignId: number,
}

const ProjectMedia = (props: ProjectMediaProps) => {
  const { campaignId } = props

  const projectMediaPayload = useImportProjectMedia(campaignId, { requestOptions })
  const {
    callbacks,
    groupedProjectMedia,
    hasGroupedProjectMedia,
  } = projectMediaPayload

  if (!hasGroupedProjectMedia) return null

  return (
    <Box flexDirection="column">
      {groupedProjectMedia.map(orderItem => (
        <OrderItem callbacks={callbacks} orderItem={orderItem} />
      ))}
    </Box>
  )
}

export default ProjectMedia
